import EventLogSvc from '@/services/EventLogSvc';
import DeviceSvc from '@/services/DeviceSvc';

const ONE_DAY_SECONDS = 24 * 60 * 60;
const MAX_TOTAL = 100;
const DEVICES_TTL_MS = 10 * 60 * 1000;

function severityOf(evt) {
  const active = Number(evt.evntStatus) === 1;
  const high = Number(evt.evntIsPriority) === 1;
  if (active && high) return 'danger';
  if (active || high) return 'warning';
  return 'info';
}

function buildEventNotifs(events, deviceMap) {
  return events
    .map((e) => ({
      id: `event-${e.evntId ?? `${e.evntDeviceId}-${e.evntTimestamp}`}`,
      severity: severityOf(e),
      title: e?.evntMevt?.mevtType || 'Event',
      status: Number(e.evntStatus) === 1 ? 'Active' : 'Resolved',
      priority: Number(e.evntIsPriority) === 1 ? 'High' : 'Normal',
      duration: Number(e.evntDuration) || 0,
      deviceId: e.evntDeviceId,
      shipName: deviceMap?.[e.evntDeviceId] || '',
      time: e.evntTimestamp,
      raw: e,
    }))
    .sort((a, b) => new Date(b.time) - new Date(a.time))
    .slice(0, MAX_TOTAL);
}

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    deviceIds: [],
    deviceMap: {},
    devicesLoadedAt: 0,
  },
  getters: {
    notifications: (state) => state.items,
    unreadCount: (state) => state.items.length,
    loading: (state) => state.loading,
    dangerCount: (state) => state.items.filter((n) => n.severity === 'danger').length,
  },
  mutations: {
    SET_ITEMS(state, items) { state.items = items; },
    SET_LOADING(state, v) { state.loading = v; },
    SET_DEVICES(state, { ids, map }) {
      state.deviceIds = ids;
      state.deviceMap = map;
      state.devicesLoadedAt = Date.now();
    },
  },
  actions: {
    async fetch({ state, commit }) {
      commit('SET_LOADING', true);
      try {
        const needsDeviceRefresh = !state.deviceIds.length
          || Date.now() - state.devicesLoadedAt > DEVICES_TTL_MS;
        if (needsDeviceRefresh) {
          try {
            const res = await DeviceSvc.getDevices({ params: { 'finds[devcType]': 'gateway' } });
            const ids = [];
            const map = {};
            (res?.data?.data || []).forEach((d) => {
              if (!d.devcUniqueId) return;
              ids.push(d.devcUniqueId);
              map[d.devcUniqueId] = d.devcMass?.massName || '';
            });
            commit('SET_DEVICES', { ids, map });
          } catch (e) {
            console.error('event notification device fetch failed:', e);
          }
        }

        if (!state.deviceIds.length) {
          commit('SET_ITEMS', []);
          return;
        }

        const end = Math.floor(Date.now() / 1000);
        const start = end - ONE_DAY_SECONDS;

        const res = await EventLogSvc.getEventLogs({
          start,
          end,
          finds: { evntDeviceId: state.deviceIds, evntIsPriority: 1 },
          orders: { evntTimestamp: 'desc' },
          params: { page: 1, max: MAX_TOTAL },
        });

        const events = res?.data || [];

        commit('SET_ITEMS', buildEventNotifs(events, state.deviceMap));
      } catch (e) {
        console.error('event notification fetch failed:', e);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
